import gql from 'graphql-tag';

export const SaveCaseMutation = gql`
  mutation saveCase($incident: CaseInput!, $name: String!, $program: String!) {
    saveCase(case: $incident, name: $name, program: $program) {
      id
      ticketNumber
      emailAddress
      title
      description
    }
  }
`;